export type ReportFileKind = "pdf" | "docx" | "unsupported";

export const DOCX_MIME_TYPE =
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const PDF_MIME_TYPE = "application/pdf";

/**
 * Storage artifacts carry their real file name inside the `object_name` query
 * parameter (e.g. `v1/storage/file?object_name=reports/notification.docx`), so the
 * extension cannot be read off the end of the URL.
 */
export const getSourceExtension = (source: string): string => {
    const decoded = decodeURIComponent(source).toLowerCase().split("#")[0];
    const fileName = decoded.includes("object_name=")
        ? decoded.split("object_name=")[1].split("&")[0]
        : decoded.split("?")[0];
    return fileName.match(/\.([a-z0-9]+)$/)?.[1] ?? "";
};

/** The file name is authoritative; storage often serves a generic content type. */
export const getReportFileKind = (source: string, mimeType?: string): ReportFileKind => {
    const extension = getSourceExtension(source);
    if (extension === "docx") return "docx";
    if (extension === "pdf") return "pdf";

    const normalizedMimeType = mimeType?.toLowerCase().split(";")[0].trim();
    if (normalizedMimeType === DOCX_MIME_TYPE) return "docx";
    if (normalizedMimeType === PDF_MIME_TYPE) return "pdf";

    return "unsupported";
};

/** A blob served as `application/octet-stream` makes the iframe download the file instead of rendering it. */
export const asPdfBlob = (blob: Blob): Blob =>
    blob.type === PDF_MIME_TYPE ? blob : new Blob([blob], { type: PDF_MIME_TYPE });
